import { render, staticRenderFns } from "./FriendLinkAdd.vue?vue&type=template&id=2fdaa4d2&scoped=true"
import script from "./FriendLinkAdd.vue?vue&type=script&lang=js"
export * from "./FriendLinkAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdaa4d2",
  null
  
)

export default component.exports